import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchDataTaller } from "../Services/fetchTallerData";
import { useBoundStore } from "useStore";

export default function useTallerData({ countryId }) {
  const { accessToken, user } = useAuth();
  const searchObject = useBoundStore((state) => state.soTallerSearch);
  const paginationModel = useBoundStore((state) => state.soTallerPaginationModel);
  const selectedStatus = useBoundStore((state) => state.soTallerSelectedStatus);

  const { searchTerm: search, startDate, endDate } = searchObject;
  const { page, pageSize } = paginationModel;
  const estadoId = selectedStatus?.id ?? 2;

  return useQuery({
    queryKey: [
      "serviceOperation",
      "tallerData",
      { countryId, estadoId, page, pageSize, search, startDate, endDate },
    ],
    queryFn: () =>
      fetchDataTaller({
        accessToken,
        user,
        countryId,
        estadoId,
        page,
        pageSize,
        search,
        startDate,
        endDate,
      }),
    staleTime: Infinity,
    enabled: !!countryId && !!accessToken,
    retry: false,
    placeholderData: (previousData) => previousData,
  });
}
